import { required, minLength, url } from 'vuelidate/lib/validators'

export default {
  organisationseinheit: {
    name: { required, minLength: minLength(1) }
  },
  titel: { required, minLength: minLength(1) },
  veroeffentlichungsnummer: { required, minLength: minLength(1) },
  haupterfinder: { required, minLength: minLength(1) },
  link: { url },
  ansprechpartner: { required, minLength: minLength(1) }
}



// WEBPACK FOOTER //
// ./src/validation/Patent.js